var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [_vm.$style.wrapper]: true, [_vm.$style[_vm.verticalFlow]]: true },style:(_vm.wrapperStyle)},[_c('div',{class:_vm.$style.inner,style:(_vm.innerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }